module.exports = __webpack_public_path__ + "img/logo_dark.8f280330.png";